

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation, State } from "vuex-class"

import TenantInfo from "@/types/tenantInfo"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import Sortable from "@/components/Controls/Sortable.vue"
import Guid from "@/scripts/guid"

import TextAreaToggleExpand from "@/components/Fields/TextAreaToggleExpand.vue"
import TeamPermissionsSelector from "@/components/Config/Permissions/TeamPermissionsSelector.vue"

import tenantApi from "@/services/api_Tenant"
import { Team } from "@/types"

const setup = namespace("setup")

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"sortable-table": Sortable,
		"text-area": TextAreaToggleExpand,
		"team-permissions-selector": TeamPermissionsSelector
	}
})
export default class TenantInfoSetup extends Vue {
	@setup.Getter("getTeams")
	teams!: Team[];

	tenantInfoItems: TenantInfo[] = []
	saving: boolean = false

	columns = [
		{
			key: "title",
			label: "Title"
		},
		{
			key: "value",
			label: "Details"
		}
	]

	get allValid (): boolean {
		return this.tenantInfoItems.every(item => this.isValid(item))
	}

	async mounted () {
		this.tenantInfoItems = this.setKeys(await tenantApi.tenantInfoGet(true))
	}

	addItem () {
		this.tenantInfoItems.push({
			key: Guid.newGuid(),
			title: "",
			value: "",
			teams: null,
			order: 0
		})
	}

	remove (itemToRemove: TenantInfo) {
		this.tenantInfoItems.removeWhere(i => i.key === itemToRemove.key)
	}

	async apply () {
		this.saving = true
		try {
			this.tenantInfoItems.forEach((item, index) => {
				item.order = index
			})

			this.tenantInfoItems = this.setKeys(await tenantApi.tenantInfoSet(this.tenantInfoItems))
		} finally {
			this.saving = false
		}
	}

	/**
	 * @summary Sets key values for info items using id (if set) or a new guid (if ID is not set)
	 */
	setKeys (items: TenantInfo[]): TenantInfo[] {
		items.filter(i => !i.key).forEach(i => i.key = i.id || Guid.newGuid())
		return items
	}

	isValid (item: TenantInfo): boolean {
		return !!item.title && (item.teams === null || item.teams.length > 0)
	}
}

